export enum ERoles {
  ADMIN = "admin",
  CUSTOMER = "customer",
}

export const RolesDashboards = [
  ERoles.ADMIN,
];

export const RolesUsers = [ERoles.CUSTOMER]